import React from 'react';
import PropTypes from 'prop-types';
import InfoMessage from './InfoMessage';
import { formatDate } from '../ContratFunctions.js'

const ConsultationUG = ({ contrats, openModal }) => {
    // Vérifier que les contrats sont un objet et contiennent des intermédiaires
    if (typeof contrats !== 'object' || Object.keys(contrats).length === 0) {
        return <p className="text-gray-700">Aucun contrat disponible pour cette vue.</p>;
    }

    return (
        <div className="px-4 space-y-8 lg:px-0">
            <InfoMessage />
            {Object.keys(contrats).map((intermediaire, index) => (
                <div key={intermediaire} className="mb-8">
                    {/* Titre de l'Intermédiaire avec couleur dynamique */}
                    <div className="p-4 overflow-hidden bg-white rounded-lg shadow-xl">
                        <h2 className={`text-3xl font-semibold text-white py-2 px-4 rounded-md mb-4 ${index % 2 === 0 ? 'bg-axa-blue-400' : 'bg-sienna-400'}`}>
                            Intermédiaire : {intermediaire}
                        </h2>
                        {/* Table des contrats */}
                        <table className="min-w-full overflow-hidden rounded-lg shadow-md bg-gray-50">
                            <thead className="text-center text-gray-700 bg-gray-200">
                                <tr>
                                    <th className="px-4 py-3">Référence</th>
                                    <th className="px-4 py-3">Nom du Souscripteur</th>
                                    <th className="px-4 py-3">Destination</th>
                                    <th className="px-4 py-3">Date de Départ</th>
                                    <th className="px-4 py-3">Date de Retour</th>
                                    <th className="px-4 py-3">Voyageurs</th>
                                    <th className="px-4 py-3">Tarif TTC (XFP)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contrats[intermediaire].map((contrat) => (
                                    <tr
                                        key={contrat.id}
                                        className="text-center transition-all duration-150 transform border-t border-gray-200 cursor-pointer hover:bg-blue-100 hover:shadow-md hover:scale-105"
                                        onClick={() => openModal(contrat)}
                                    >
                                        <td className="px-4 py-2 font-medium text-gray-700">
                                            {contrat.data.reference}
                                        </td>
                                        <td className="px-4 py-2 font-medium text-gray-800">
                                            {contrat.data.souscripteur.nomEpouse ? `${contrat.data.souscripteur.nom} ep ${contrat.data.souscripteur.nomEpouse}` : contrat.data.souscripteur.nom} {contrat.data.souscripteur.prenom}
                                        </td>
                                        <td className="px-4 py-2">
                                            {contrat.data.souscripteur.destination}
                                        </td>
                                        <td className="px-4 py-2">
                                            {formatDate(contrat.data.souscripteur.dateDepart)}
                                        </td>
                                        <td className="px-4 py-2">
                                            {formatDate(contrat.data.souscripteur.dateRetour)}
                                        </td>
                                        <td className="px-4 py-2">
                                            {contrat.data.personnes.length}
                                        </td>
                                        <td className="px-4 py-2">
                                            {contrat.data.contrat.tarif.totalTTC.toLocaleString('fr-FR', { minimumFractionDigits: 0 })} XPF
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    );
};

ConsultationUG.propTypes = {
    contrats: PropTypes.object.isRequired,
    openModal: PropTypes.func.isRequired
};

export default ConsultationUG;
